export default __webpack_public_path__ + "static/media/IMG_2721.b7ae6608.jpg";